// An EventMap specifies the types of events and what payload they expect.
// This allows for type-safe event handling in TypeScript.
type EventMap = {
    [event: string]: any;
};

// A generic event emitter which can be used anywhere with customizable event shapes & naming.
// TODO: 'once' listeners
export class EventEmitter<T extends EventMap> {
    private listeners: {
        [K in keyof T]?: Array<(payload: T[K]) => void>;
    } = {};

    // Add a listener for a specific event type
    on<K extends keyof T>(event: K, listener: (payload: T[K]) => void): void {
        if (!this.listeners[event]) {
            this.listeners[event] = [];
        }
        this.listeners[event]!.push(listener);
    }

    // Remove a listener for a specific event type
    off<K extends keyof T>(event: K, listener: (payload: T[K]) => void): void {
        if (!this.listeners[event]) return;
        this.listeners[event] = this.listeners[event]!.filter((l) => l !== listener);
    }

    // Emit an event with the given payload
    emit<K extends keyof T>(event: K, payload: T[K]): void {
        if (!this.listeners[event]) return;
        for (const listener of this.listeners[event]!) {
            listener(payload);
        }
    }

    // Clear all listeners for a specific event or all events
    clear<K extends keyof T>(event?: K): void {
        if (event) {
            delete this.listeners[event];
        } else {
            for (const key in this.listeners) {
                delete this.listeners[key as keyof T];
            }
        }
    }
}
